import chooseOne from "./questions/choose_one.jst";
import selectOne from "./questions/select_one.jst";
import chooseMany from "./questions/choose_many.jst";
import followUp from "./questions/follow_up.jst";
import shortAnswer from "./questions/short_answer.jst";
import longAnswer from "./questions/long_answer.jst";

export default {
    chooseOne,
    selectOne,
    chooseMany,
    shortAnswer,
    longAnswer,
    followUp,
};
